import React from 'react'

import { Button, ArrowLeftIcon } from '@pb/components'
import { getLabelFromStorage, isArketBrand, isCosBrand, isOtherStoriesBrand } from '@pb/utils'

import styles from './BackNavigationLayout.scss'
import { Props } from './types'

const BackNavigationLayout: React.FC<Props> = ({ status, handleBackButtonClick }) => {
  if (!status) {
    return null
  }

  let buttonContainer
  switch (true) {
    case isOtherStoriesBrand:
      buttonContainer = styles.storiesContainer
      break
    case isArketBrand:
      buttonContainer = styles.arketContainer
      break
    case isCosBrand:
      buttonContainer = styles.cosContainer
      break
    default:
      buttonContainer = styles.container
      break
  }

  return (
    <div className="u-row u-full-width">
      <div className="contain">
        <div className="u-cols-lg-24-24 u-cols-md-24-24 u-cols-sm-12-12">
          <div className={buttonContainer}>
            <Button
              Tag="button"
              onClick={handleBackButtonClick}
              secondary
              iconElement={<ArrowLeftIcon />}
              className={styles.backButton}
            >
              {getLabelFromStorage('profile.unreviewedproducts.review.page.back.button')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BackNavigationLayout
